import { Avatar, Pagination, Text } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { IconPencil, IconTrash } from '@tabler/icons-react'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useUsersList } from '../../api/hooks/Users/userUsersList'
import { useUsersDelete } from '../../api/hooks/Users/useUsersDelete'
import EditUserModal from './EditUserModal'
import UserListHeader from './UserListHeader'
import UserListHeaderSection from './UserListHeaderSection'
import UserListItem from './UserListItem'
import { openConfirmModal } from '@mantine/modals'
import { Icon } from '../../assets/icons'
import styles from '../../styles/manager/UserList.module.scss'

const USERS_PER_PAGE = 10

const UserList = () => {
  const { state } = useLocation()
  const centerId = state?.centerId
  const [editModalOpened, setEditModalOpened] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [filters, setFilters] = useState({
    level: '',
    name: '',
    phone: '',
    state: '',
  })

  const { data: usersResponse } = useUsersList({
    CENTER_ID: centerId,
    LEVEL: filters.level,
    NAME: filters.name,
    PHONE: filters.phone,
    STATE: filters.state,
  })
  const deleteUserMutation = useUsersDelete()
  const users = usersResponse?.data || []
  const totalPages = Math.ceil(users.length / USERS_PER_PAGE)
  const currentUsers = users.slice(
    (currentPage - 1) * USERS_PER_PAGE,
    currentPage * USERS_PER_PAGE
  )

  const handleDeleteClick = (user: any) => {
    openConfirmModal({
      title: '정말 삭제하시겠습니까?',
      children: (
        <Text size="sm">
          {user.NAME} 고객을 삭제하면 복구할 수 없습니다. 정말 삭제하시겠습니까?
        </Text>
      ),
      labels: { confirm: '삭제', cancel: '취소' },
      confirmProps: { color: 'red' },
      onConfirm: () => {
        deleteUserMutation.mutate(
          { ID: user.ID },
          {
            onSuccess: () => {
              notifications.show({
                title: 'Success',
                message: 'User deleted successfully',
                color: 'green',
              })
            },
            onError: () => {
              notifications.show({
                title: 'Error',
                message: 'Failed to delete user. Please try again.',
                color: 'red',
              })
            },
          }
        )
      },
    })
  }

  const handleModifyClick = (user: any) => {
    setSelectedUser(user)
    setEditModalOpened(true)
  }

  return (
    <div
      style={{
        backgroundColor: '#ffff',
        padding: '25px',
        borderRadius: '15px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
      }}
    >
      <UserListHeaderSection
        filters={filters}
        onSearch={(updated) => setFilters(updated)}
      />
      <div className={styles.listWrapper}>
        <UserListHeader />
        {currentUsers.map((user: any) => (
          <UserListItem
            key={user.ID}
            Name={user.NAME}
            Level={user.LEVEL}
            School={user.SCHOOL}
            Phone={user.PHONE}
            Email={user.EMAIL}
            Center={user.CENTER_NAME}
            Modify={
              <Icon
                name="pen"
                color="#b6bfca"
                onClick={() => handleModifyClick(user)}
                size={16}
              />
            }
            Delete={
              <Icon
                name="trash"
                color="#b6bfca"
                onClick={() => handleDeleteClick(user)}
                size={16}
              />
            }
          />
        ))}
      </div>

      <EditUserModal
        opened={editModalOpened}
        onClose={() => setEditModalOpened(false)}
        userData={selectedUser}
      />

      {totalPages > 1 && (
        <Pagination
          total={totalPages}
          value={currentPage}
          onChange={setCurrentPage}
          color="gray"
          mt="md"
        />
      )}
    </div>
  )
}

export default UserList
